import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=0ac7677e&scoped=true&"
import script from "./error.js?vue&type=script&lang=js&"
export * from "./error.js?vue&type=script&lang=js&"
import style0 from "./error.scss?vue&type=style&index=0&id=0ac7677e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac7677e",
  null
  
)

export default component.exports